(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-menu-image"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    $('.megamenu-images-replacement > div').each(function () {
      $($(this).data('class')).find('.megamenu-images').html($(this).html());
      const wrapper = $($(this).data('class'));
      const children = wrapper.find('.megamenu-images').children();
      const numberOfImages = children.length;
      
      if (!numberOfImages) return;

      let menuWidth = '6fr';
      if (numberOfImages == 1) {
        menuWidth = '5fr'
      } else if (numberOfImages == 2) {
        menuWidth = '4fr'
      }

      const maxWidth = (numberOfImages * 300) + 'px';

      wrapper.attr(
        `style`,
        `--imageCols: ${numberOfImages}; grid-template-columns: minmax(0, ${menuWidth}) minmax(0, ${maxWidth});`
      );
    });
  });

  } catch(e) { console.error(e); }
})();
})();
